<template>
  <div id="app">
    <colors />
    <fonts />
    <div id="headerImg" />
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/biography">Biographie</router-link> |
      <router-link to="/songs">Eigene Songs</router-link> |
      <router-link to="/contact">Kontakt</router-link>
    </div>
    <router-view />
    <div id="footer">
      <router-link to="/imprint">Impressum</router-link> |
      <router-link to="/datenschutz">Datenschutz</router-link>
    </div>
  </div>
</template>

<script>
import colors from './views/Colors.vue';
import fonts from './views/Fonts.vue';

export default {
  components: {
    colors,
    fonts,
  },
};
</script>

<style>
#himg {
  width: 100%;
  height: auto;
}

#headerImg {
  width: 100%;
  height: 20rem;
  background: no-repeat 50% 10% url("./assets/PferdenarrZaun.jpg");
  background-size: cover;
}

h1 {
  font-family: "Raleway", sans-serif;
  font-size: 3em;
}

h2 {
  font-family: "Raleway", sans-serif;
  font-size: 2.5em;
}

h3 {
  font-size: 1.4em;
}

p {
  font-size: 1.2rem;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--text);
  font-family: "Montserrat", sans-serif;
}

#nav {
  font-size: 1.1em;
  background-color: var(--secondary);
  color: var(--light);
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: var(--light);
  text-decoration: none;
}

#nav a.router-link-exact-active {
  color: var(--primary);
}

#footer {
  margin-top: 15rem;
  padding: 20px;
  background-color: var(--highlight);
  color: var(--light);
}

#footer a {
  font-weight: bold;
  color: var(--light);
}

#footer a.router-link-exact-active {
  color: var(--secondary);
}

@media screen and (min-width: 480px) and (max-width:849px) {
  #headerImg {
    width: 100%;
    height: 25rem;
    background: no-repeat 50% 10% url("./assets/PferdenarrZaun.jpg");
    background-size: cover;
  }
}

@media screen and (min-width: 850px) {
  #headerImg {
    width: 100%;
    height: 30rem;
    background: no-repeat 50% 10% url("./assets/PferdenarrZaun.jpg");
    background-size: cover;
  }
}
</style>
